/* eslint 'array-callback-return': 'off','no-new-object': 'off','no-array-constructor': 'off','no-redeclare': 'off', 'jsx-a11y/anchor-is-valid': 'off', eqeqeq: 'off'  */
import React, { Component } from 'react';
import { Row, Col, Button, Label, Modal } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import '../../../../../../Assets/EnsembleStyles/EnsCreateTenant.css';
import { FaQuestionCircle } from 'react-icons/fa';
import TimeCustomization from '../../../../Common/Layouts/Widgets/TimeCustomization';
import ConfirmClearAllDays from '../../_ModalsForms/ClearAllNormalHoursConfirmation';
import AddHoursPeriod from '../../_ModalsForms/AddHoursPeriod';
import classnames from 'classnames';
import Conversions from '../../../../../../Resources/Conversions';
import { SaveNormalHoursDetailsforclient } from '../../../../../../action/manageTenantAction';
import { connect } from 'react-redux';
import { getAllResources } from '../../../../../../action/cultureAction';
import CustomDropdown from '../CustomDropdown';
import ReactDOM from 'react-dom';

let disabled_States = [];
class CreateTenant_NormalHours extends Component {
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('wheel', this.handleMouseScroll);
        document.removeEventListener('mousewheel', this.preventScrollPropagation); 
    }

    componentDidMount() {
        if (this.props.getLabels["ManageTenants.Create.Text"] === undefined) {
            this.props.getAllResources();
        }
        var Hours_Slider_div = document.getElementsByClassName('hours');let AllZonesNormalHours = [];
        this.SetDefaultNormalHours();
        if (this.props.ClientSideZonesState !== undefined && this.props.ClientSideZonesState !== null && this.props.ClientSideZonesState.length){
            for(let j=0; j<this.props.ClientSideZonesState.length; j++){
                for(let i=0;i<7;i++){
                    if(i === 6 || i === 0){
                        AllZonesNormalHours.push({
                            "dayId": i,
                            "zoneId": Number(this.props.ClientSideZonesState[j].zoneId),
                            "startTime": Conversions.ConvertValueto24hourTime(0),
                            "endTime":Conversions.ConvertValueto24hourTime(0)
                        })
                    }else{
                        AllZonesNormalHours.push({
                            "dayId": i,
                            "zoneId": Number(this.props.ClientSideZonesState[j].zoneId),
                            "startTime": Conversions.ConvertValueto24hourTime(480),
                            "endTime":Conversions.ConvertValueto24hourTime(1020)
                        })
                    }
                }             
            }
            for (let i = 0; i < 7; i++) {
                AllZonesNormalHours.push({
                    "dayId": i,
                    "zoneId": -1,
                    "startTime": Conversions.ConvertValueto24hourTime(0),
                    "endTime": Conversions.ConvertValueto24hourTime(0)
                })
            }
            if (this.props.ClientSideNormalHourState != undefined && this.props.ClientSideNormalHourState != null && this.props.ClientSideNormalHourState.length){
                let ClientZones = this.props.ClientSideNormalHourState;
                ClientZones = ClientZones.filter(item => this.props.ClientSideZonesState.some(val => Number(val.zoneId) === Number(item.zoneId))); //Remove zones details for user deleted zones.
                AllZonesNormalHours = [...AllZonesNormalHours.filter(e => !ClientZones.some(el => Number(el.zoneId) === Number(e.zoneId))),...ClientZones];
                let data = ClientZones !== undefined && ClientZones !== null && ClientZones.length ? ClientZones.filter(x => Number(x.zoneId) === Number(this.state.SelectedZoneID)) : [];
                for (var i = 0; i < Hours_Slider_div.length; i++) {
                    Hours_Slider_div[i].style.display = 'none';
                }
                for (var i = 0; i < data.length; i++) {
                    if (data[i].startTime == data[i].endTime)
                        continue;
                    switch (data[i].dayId) {
                        case 0:
                            this.setState({
                                Sunday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                            });
                            Hours_Slider_div[0].style.display = 'inline';
                            break;
                        case 1:
                            this.setState({
                                Monday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                            });
                            Hours_Slider_div[1].style.display = 'inline';
                            break;
                        case 2:
                            this.setState({
                                Tuesday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                            });
                            Hours_Slider_div[2].style.display = 'inline';
                            break;
                        case 3:
                            this.setState({
                                Wednesday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                            });
                            Hours_Slider_div[3].style.display = 'inline';
                            break;
                        case 4:
                            this.setState({
                                Thursday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                            });
                            Hours_Slider_div[4].style.display = 'inline';
                            break;
                        case 5:
                            this.setState({
                                Friday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                            });
                            Hours_Slider_div[5].style.display = 'inline';
                            break;
                        case 6:
                            this.setState({
                                Saturday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                            });
                            Hours_Slider_div[6].style.display = 'inline';
                            break;
                        default:
                            break;
                    }
                }
            }
            this.setState({ ZonesHours : AllZonesNormalHours })
        }

        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('wheel', this.handleMouseScroll);
        document.addEventListener('mousewheel', this.preventScrollPropagation);
    }
        
    SetDefaultNormalHours(){
         var Hours_Slider_div = document.getElementsByClassName('hours');
        for (var i = 0; i < Hours_Slider_div.length; i++) {
            if (Hours_Slider_div[i] != null) {
                if(this.props.ClientSideZonesState !== null && this.props.ClientSideZonesState !== undefined && this.props.ClientSideZonesState.length){
                    if (i == 6 || i == 0)
                        Hours_Slider_div[i].style.display = 'none';
                    else
                        Hours_Slider_div[i].style.display = 'inline';
                }else{
                    Hours_Slider_div[i].style.display = 'none';
                }
            }
        }   
    }

    constructor(props) {
        super(props);
        this.state = {
            routeModules: {
            },
            redirect: false,
            redirectBack: false,
            modal: false,
            addhours_modal: false,
            Sunday: [0, 0],
            Monday: [480, 1020],
            Tuesday: [480, 1020],
            Wednesday: [480, 1020],
            Thursday: [480, 1020],
            Friday: [480, 1020],
            Saturday: [0, 0],
            ZonesHours: [],
            SelectedZoneID: (this.props.ClientSideZonesState !== undefined && this.props.ClientSideZonesState !== null && this.props.ClientSideZonesState.length) ? Number(this.props.ClientSideZonesState[0].zoneId) : 0,
            SelectedZoneName: (this.props.ClientSideZonesState !== undefined && this.props.ClientSideZonesState !== null && this.props.ClientSideZonesState.length) ? this.props.ClientSideZonesState[0].zoneName : '',
            ZoneDropDownStyles: {
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: "9999",
                width: "200px",
                maxHeight: "300px",
                overflowY: "auto",
                border: "1px solid black",
                backgroundColor: "white",
                display: "none",
                "overscroll-behavior-y": "contain" 
            }
        }
        this.goNext = this.goNext.bind(this);
        this.goBack = this.goBack.bind(this);
        this.toggle = this.toggle.bind(this);
        this.AddHourstoggle = this.AddHourstoggle.bind(this);
        this.someFunctionHere = this.someFunctionHere.bind(this);
        this.SelectAssignedZone = this.SelectAssignedZone.bind(this);
        this.OnSliderChange = this.OnSliderChange.bind(this);
        this.SetDefaultNormalHours = this.SetDefaultNormalHours.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleMouseScroll = this.handleMouseScroll.bind(this);
        this.preventScrollPropagation = this.preventScrollPropagation.bind(this);
        this.ComputeStyle = this.ComputeStyle.bind(this);
        this.setZone = this.setZone.bind(this);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            let StateChange = { ...this.state.ZoneDropDownStyles };
            StateChange.display = "none";
            this.setState({ ZoneDropDownStyles: StateChange });
        }
    }
      
    handleMouseScroll(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            let StateChange = { ...this.state.ZoneDropDownStyles };
            StateChange.display = "none";
            this.setState({ ZoneDropDownStyles: StateChange });
        }
    }
      
    preventScrollPropagation(event){
        if(this.wrapperRef && this.wrapperRef.contains(event.target)){         //Tenant Dropdown
            var scrollDown = event.wheelDelta < 0;
            if(scrollDown){
                var isAtBottom = this.wrapperRef.scrollTop + this.wrapperRef.clientHeight == this.wrapperRef.scrollHeight;
                if(isAtBottom){
                    event.preventDefault();
                }
            }
            else{
                var isAtTop = this.wrapperRef.scrollTop === 0;
                if(isAtTop){
                    event.preventDefault();
                }
            }
        }
    }
      
    ComputeStyle() {
        var offset = ReactDOM.findDOMNode(this.refs.zoness_in_Select_input).getBoundingClientRect();
        let StateChange = { ...this.state.ZoneDropDownStyles };
        StateChange.display = "block";
        StateChange.top = parseInt(offset.top) + parseInt(offset.height) + 1;
        StateChange.left = parseInt(offset.left);
        this.setState({ ZoneDropDownStyles: StateChange });
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    setZone(ZoneID, ZoneName){
        let StateChange = { ...this.state.ZoneDropDownStyles };
        StateChange.display = "none";
      
        this.setState({
            SelectedZoneID: ZoneID,
            SelectedZoneName: ZoneName,
            ZoneDropDownStyles: StateChange,
        });
        this.SelectAssignedZone(ZoneID);
    }

    goBack() {
        this.setState({ redirectBack: true });
    }

    goNext(e) {
        var NormalHoursEditedData = [];
        if (this.state.SelectedZoneID === -1 && this.state.SelectedZoneName === 'Select All') {
            let WithSelectAllData = this.state.ZonesHours !== undefined && this.state.ZonesHours !== null && this.state.ZonesHours.length ? this.state.ZonesHours.filter(x => Number(x.zoneId) === -1) : [];
            if (WithSelectAllData !== undefined && WithSelectAllData !== null && WithSelectAllData.length) {
                var AllUpdatedZoneHours = [];
                for (var i = 0; i < this.props.ClientSideZonesState.length; i++) {
                    for (var j = 0; j < 7; j++) {
                        AllUpdatedZoneHours.push({
                            "zoneId": Number(this.props.ClientSideZonesState[i].zoneId),
                            "dayId": WithSelectAllData[j].dayId,
                            "startTime": WithSelectAllData[j].startTime,
                            "endTime": WithSelectAllData[j].endTime
                        })
                    }
                }
                NormalHoursEditedData = AllUpdatedZoneHours;
            }
        } else {
            NormalHoursEditedData = (this.state.ZonesHours !== undefined && this.state.ZonesHours !== null && this.state.ZonesHours.length) ? this.state.ZonesHours : [];
        }
        this.setState({ redirect: true });
        this.props.SaveNormalHoursDetailsforclient(NormalHoursEditedData);
    }

    toggle() {
        this.setState({ modal: !this.state.modal });
    }

    AddHourstoggle() {
        var Hours_Slider_div = document.getElementsByClassName('hours');
        for (var i = 0; i < 7; i++) {
            if (Hours_Slider_div[i].style.display == 'none') {
                disabled_States.push(i);
            }
        }
        this.setState({ addhours_modal: !this.state.addhours_modal });
    }

    someFunctionHere(data) {
        this.AddHourstoggle();
        if (data != null && data.selected_days != null) {
            let AddedHoursForNewZone = [];
            var Hours_Slider_div = document.getElementsByClassName('hours');
            disabled_States = [];
            for (var i = 0; i < data.selected_days.length; i++) {
                switch (data.selected_days[i]) {
                    case "0":
                        this.setState({
                            Sunday: [data.hours_period[0], data.hours_period[1]]
                        });
                        AddedHoursForNewZone.push({
                            "zoneId": this.state.SelectedZoneID,
                            "dayId": 0,
                            "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
                            "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
                          })
                        Hours_Slider_div[0].style.display = 'inline';
                        break;
                    case "1":
                        this.setState({
                            Monday: [data.hours_period[0], data.hours_period[1]]
                        });
                        AddedHoursForNewZone.push({
                            "zoneId": this.state.SelectedZoneID,
                            "dayId": 1,
                            "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
                            "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
                          })
                        Hours_Slider_div[1].style.display = 'inline';
                        break;
                    case "2":
                        this.setState({
                            Tuesday: [data.hours_period[0], data.hours_period[1]]
                        });
                        AddedHoursForNewZone.push({
                            "zoneId": this.state.SelectedZoneID,
                            "dayId": 2,
                            "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
                            "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
                          })
                        Hours_Slider_div[2].style.display = 'inline';
                        break;
                    case "3":
                        this.setState({
                            Wednesday: [data.hours_period[0], data.hours_period[1]]
                        });
                        AddedHoursForNewZone.push({
                            "zoneId": this.state.SelectedZoneID,
                            "dayId": 3,
                            "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
                            "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
                          })
                        Hours_Slider_div[3].style.display = 'inline';
                        break;
                    case "4":
                        this.setState({
                            Thursday: [data.hours_period[0], data.hours_period[1]]
                        });
                        AddedHoursForNewZone.push({
                            "zoneId": this.state.SelectedZoneID,
                            "dayId": 4,
                            "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
                            "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
                          })
                        Hours_Slider_div[4].style.display = 'inline';
                        break;
                    case "5":
                        this.setState({
                            Friday: [data.hours_period[0], data.hours_period[1]]
                        });
                        AddedHoursForNewZone.push({
                            "zoneId": this.state.SelectedZoneID,
                            "dayId": 5,
                            "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
                            "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
                          })
                        Hours_Slider_div[5].style.display = 'inline';
                        break;
                    case "6":
                        this.setState({
                            Saturday: [data.hours_period[0], data.hours_period[1]]
                        });
                        AddedHoursForNewZone.push({
                            "zoneId": this.state.SelectedZoneID,
                            "dayId": 6,
                            "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
                            "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
                          })
                        Hours_Slider_div[6].style.display = 'inline';
                        break;
                    default:
                        break;
                }
            }
            for (var i = 0; i < 7; i++) {
                // if(!data.selected_days.includes(i.toString())){
                //     AddedHoursForNewZone.push({
                //       "zoneId": this.state.SelectedZoneID,
                //       "dayId": i,
                //       "startTime": Conversions.ConvertValueto24hourTime(0),
                //       "endTime": Conversions.ConvertValueto24hourTime(0)
                //     })
                // }
                if (Hours_Slider_div[i].style.display == 'none') {
                    disabled_States.push(i);
                }
            }

            let SelectedZoneData = this.state.ZonesHours !== undefined && this.state.ZonesHours !== null && this.state.ZonesHours.length ? this.state.ZonesHours.filter(x => x.zoneId === this.state.SelectedZoneID) : []
            if (SelectedZoneData === undefined || SelectedZoneData === null || SelectedZoneData.length <= 0) {
                let MergedData = [...this.state.ZonesHours, ...AddedHoursForNewZone];
                this.setState({ ZonesHours: MergedData });
            }
            else {
                let MergedData = [...this.state.ZonesHours.filter(e => !AddedHoursForNewZone.some(el => el.zoneId === e.zoneId && el.dayId === e.dayId)), ...AddedHoursForNewZone];
                this.setState({ ZonesHours: MergedData });
            }
        }
    }

    ClearAllDays = (e) => {
        this.toggle();
        this.setState(prevState => ({
            ZonesHours: prevState.ZonesHours.map(item => ( Number(item.zoneId) === Number(this.state.SelectedZoneID)) ? {...item, startTime:Conversions.ConvertValueto24hourTime(0),endTime:Conversions.ConvertValueto24hourTime(0)} : item)
        }))
        
        var Hours_Slider_div = document.getElementsByClassName('hours');
        for (var i = 0; i < Hours_Slider_div.length; i++)
            Hours_Slider_div[i].style.display = 'none';
    }

    SelectAssignedZone(selectedZoneID){
        let data = this.state.ZonesHours !== undefined && this.state.ZonesHours !== null && this.state.ZonesHours.length ? this.state.ZonesHours.filter(x => x.zoneId === Number(selectedZoneID)) : []
    
        var Hours_Slider_div = document.getElementsByClassName('hours');
        for (var i = 0; i < Hours_Slider_div.length; i++) {
            Hours_Slider_div[i].style.display = 'none';
        }
    
        if (data !== undefined && data !== null && data.length) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].startTime == data[i].endTime)
              continue;
            switch (data[i].dayId) {
              case 0:
                this.setState({
                  Sunday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[0].style.display = 'inline';
                break;
              case 1:
                this.setState({
                  Monday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[1].style.display = 'inline';
                break;
              case 2:
                this.setState({
                  Tuesday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[2].style.display = 'inline';
                break;
              case 3:
                this.setState({
                  Wednesday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[3].style.display = 'inline';
                break;
              case 4:
                this.setState({
                  Thursday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[4].style.display = 'inline';
                break;
              case 5:
                this.setState({
                  Friday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[5].style.display = 'inline';
                break;
              case 6:
                this.setState({
                  Saturday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[6].style.display = 'inline';
                break;
              default:
                break;
            }
          }
        }
    }

    OnSliderChange(DayID, e){
        let startTime = Conversions.ConvertValueto24hourTime(Math.ceil(e.values[0] / 15) * 15);
        let endTime = Conversions.ConvertValueto24hourTime(Math.ceil(e.values[1] / 15) * 15);
        //To Handle Select All Functionality
        if (this.state.SelectedZoneID === -1 && this.state.SelectedZoneName === 'Select All') {
            this.setState(prevState => ({
                ZonesHours: prevState.ZonesHours.map(item => (
                  DayID === item.dayId ? { ...item, startTime, endTime } : item
                ))
              }))
        }else{
            this.setState(prevState => ({
                ZonesHours: prevState.ZonesHours.map(item => (
                  Number(this.state.SelectedZoneID) === item.zoneId && DayID === item.dayId ? { ...item, startTime, endTime } : item
                ))
              }))
        }
    }

    render(ClientSideNormalHourState, getLabels) {
        let label = this.props.getLabels;
        if (this.state.redirect) {
            return <Redirect to={"/managetenant/TenantEmployeeUsers"} />
        }
        if (this.state.redirectBack) {
            return <Redirect to={"/managetenant/TenantAfterHours"} />
        }

        // let AssignedZones = [];
        // if (this.props.ClientSideZonesState !== undefined && this.props.ClientSideZonesState !== null && this.props.ClientSideZonesState.length){
        //     AssignedZones = this.props.ClientSideZonesState.map(el =>(
        //         <option value={el.zoneId} key={el.zoneId}>{el.zoneName}</option>
        //     ));
        // }

        return (
            <div className="EnsembleCreateTenant">
                <Row>
                    <Col sm={{ size: 1, offset: 11 }} className="text-right" >
                        <FaQuestionCircle className="Ensemble_Icon Ensemble_question_Icon" />
                    </Col>
                </Row>
                <h4 className="form_title">{label['AddEditSubGroups.PageHeader.NormalHours.Text']}</h4>
                <div className="Customised_form_div ">
                    <Label >{label['CreateTenant.lblUATextNormalHoursInfo.Text']}
                    </Label>
                    <div style={{"margin-top":"15px", "margin-bottom":"15px"}}>
                        <Row>
                            <Col style={{ "max-width": "12%" }}>
                                <span style={{ "font-size": "13px", "position": "relative", "top": "-10px", "color": "black" }}><b>Assigned Zones</b><br />
                                    <input type="text" ref='zoness_in_Select_input' style={{ width: '150px', height: '22px', backgroundColor: 'white' }} className="minimal workorderedit-dropdown" placeholder={this.state.SelectedZoneID === 0 ? "--Select--" : this.state.SelectedZoneName} onClick={this.ComputeStyle} />
                                    {/* <select id='rdl_Assigned_zones' ref='AssignedZones_in_Select_input' onChange={this.SelectAssignedZone} className="InputFieldStyle" style={{ "height": "22px", "width": "150px" }}>
                                        {AssignedZones}
                                    </select> */}
                                </span>
                            </Col><Col>
                                <Button type="button" id="createtenant_NH_addhr" className="btn btn-black" onClick={this.AddHourstoggle} >{label['NormalHours.AddHours.Text']}  </Button>
                                <Button type="button" id="createtenant_NH_clearhr" className="btn btn-black" onClick={this.toggle} >{label['NormalHours.ClearAllDays.Text']}  </Button>
                            </Col>
                        </Row>
                    </div>
                    <table className="Hours_details" striped>
                        <thead>
                            <tr className="slider_row">
                                <td className="day">&nbsp;</td>
                                <td ><span>
                                    <p className="hours_number">12 AM</p>
                                    <p className="hours_number">2:00</p>
                                    <p className="hours_number">4:00</p>
                                    <p className="hours_number">6:00</p>
                                    <p className="hours_number">8:00</p>
                                    <p className="hours_number">10:00</p>
                                    <p className="hours_number">12 PM</p>
                                    <p className="hours_number">2:00</p>
                                    <p className="hours_number">4:00</p>
                                    <p className="hours_number">6:00</p>
                                    <p className="hours_number">8:00</p>
                                    <p className="hours_number">10:00</p>
                                </span>
                                </td></tr>
                        </thead>
                    </table>

                    <table className="Hours_widget" striped>
                        <tbody>
                            <tr className="slider_row"><td className="day"><p>Sunday</p></td><td ><div className="hours" ><TimeCustomization max={1440} values={this.state.Sunday} min={0} onChange={e => {this.OnSliderChange(0,e);this.setState({ Sunday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })}} /></div></td></tr>
                            <tr className="slider_row"><td className="day"><p>Monday</p></td><td><div className="hours" ><TimeCustomization max={1440} values={this.state.Monday} min={0} onChange={e => {this.OnSliderChange(1,e);this.setState({ Monday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })}} /></div></td></tr>
                            <tr className="slider_row"><td className="day"><p>Tuesday</p></td><td><div className="hours" ><TimeCustomization max={1440} values={this.state.Tuesday} min={0} onChange={e => {this.OnSliderChange(2,e);this.setState({ Tuesday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })}} /></div></td></tr>
                            <tr className="slider_row"><td className="day"><p>Wednesday</p></td><td><div className="hours" ><TimeCustomization max={1440} values={this.state.Wednesday} min={0} onChange={e => {this.OnSliderChange(3,e);this.setState({ Wednesday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })}} /></div></td></tr>
                            <tr className="slider_row"><td className="day"><p>Thursday</p></td><td><div className="hours" ><TimeCustomization max={1440} values={this.state.Thursday} min={0} onChange={e => {this.OnSliderChange(4,e);this.setState({ Thursday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })}}/></div></td></tr>
                            <tr className="slider_row"><td className="day"><p>Friday</p></td><td><div className="hours" ><TimeCustomization max={1440} values={this.state.Friday} min={0} onChange={e => {this.OnSliderChange(5,e);this.setState({ Friday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })}} /></div></td></tr>
                            <tr className="slider_row"><td className="day"><p>Saturday</p></td><td><div className="hours" ><TimeCustomization max={1440} values={this.state.Saturday} min={0} onChange={e => {this.OnSliderChange(6,e);this.setState({ Saturday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })}} /></div></td></tr>
                        </tbody>
                    </table>

                    <Button type="button" id="createtenant_NH_back" className="btn btn-gray" onClick={this.goBack}>{label['Wizards.BackButton.Text']}</Button>
                    <Button type="button" id="createtenant_NH_next" className="btn btn-success" onClick={this.goNext}>{label['Wizards.NextButton.Text']}</Button>
                    
                </div>

                {/* Add Hours Period Modal */}
                <Modal isOpen={this.state.addhours_modal} addhours_modal={this.addhours_modal} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    <AddHoursPeriod someFunctionHere={this.someFunctionHere} disabled_States={disabled_States} />
                </Modal>

                {/* Clear All Days Modal */}
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    <ConfirmClearAllDays ClearAllDays={this.ClearAllDays} toggle={this.toggle} />
                </Modal>

                <CustomDropdown name="tenantdropdown" refMethod={this.setWrapperRef} groupname="rdTenant" data={this.props.ClientSideZonesState} elementStyle={this.state.ZoneDropDownStyles} setValue={this.setZone} SelectedZoneID={this.state.SelectedZoneID} />
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        ClientSideNormalHourState: state.manageTenant.ClientSideNormalHoursData,
        ClientSideZonesState: state.manageTenant.ClientSideZonesData,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        SaveNormalHoursDetailsforclient: (data) => dispatch(SaveNormalHoursDetailsforclient(data)),
        getAllResources: () => dispatch(getAllResources())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateTenant_NormalHours)



